import { jsxs, jsx } from 'react/jsx-runtime';
import cn from 'classnames';
import { Button } from '../../Button/Button.js';
import { Icon } from '../../Icon/Icon.js';
import S from './Item.styl.js';

function Item(props) {
    const { className, img, total, loaded, waitingForUpload, children, onRemove, ...rest } = props;
    const style = {};
    const isComplete = loaded === total;
    const isLoading = !isComplete && loaded > 0;
    const classes = cn(S.root, waitingForUpload && S.waitingForUpload, isLoading && S.loading, className);
    if (img)
        style.backgroundImage = `url(${img})`;
    return (jsxs("div", { ...rest, className: classes, style: style, children: [children, jsx(Button, { className: S.removeButton, size: "s", variant: "clear", square: true, onClick: onRemove, children: jsx(Icon, { type: "delete" }) }), jsx("div", { className: cn(S.progress, isComplete && S.complete), style: { left: `${(loaded / total) * 100 - 100}%` } }), jsx("div", { className: S.overlay })] }));
}

export { Item as default };
